import { rufe } from './client';

/** WEB-10 i.d.F. AeA-37: die Zuordnung neuer Online-Konten zu Kunden. */
export type Zuordnungskandidat = {
  readonly kunde: string;
  readonly kundennummer: string;
  readonly name: string;
  readonly ueber: readonly ('kunde' | 'ansprechpartner')[];
  readonly andersVerbunden: boolean;
};

export type Kontozuordnung = {
  readonly id: string;
  readonly konto: string;
  readonly email: string;
  readonly ergebnis: 'automatisch' | 'mehrdeutig';
  readonly kunde: { readonly id: string; readonly kundennummer: string; readonly name: string } | null;
  readonly kandidaten: readonly Zuordnungskandidat[];
  readonly angelegtAm: string;
  readonly erledigtAm: string | null;
  readonly erledigung: 'zugeordnet' | 'verworfen' | 'zurueckgenommen' | null;
  readonly grund: string | null;
  readonly offen: boolean;
  readonly ruecknehmbar: boolean;
};

export const ERLEDIGUNGSNAME: Readonly<Record<NonNullable<Kontozuordnung['erledigung']>, string>> = {
  zugeordnet: 'von Hand zugeordnet',
  verworfen: 'verworfen',
  zurueckgenommen: 'zurückgenommen',
};

export async function liste(alle: boolean): Promise<readonly Kontozuordnung[]> {
  const { zuordnungen } = await rufe<{ zuordnungen: readonly Kontozuordnung[] }>(
    alle ? '/kontozuordnungen?alle=ja' : '/kontozuordnungen',
  );
  return zuordnungen;
}

export async function zuordnen(id: string, kunde: string): Promise<Kontozuordnung> {
  return rufe(`/kontozuordnungen/${id}/zuordnen`, { verfahren: 'POST', rumpf: { kunde } });
}

export async function verwerfen(id: string, grund: string): Promise<Kontozuordnung> {
  return rufe(`/kontozuordnungen/${id}/verwerfen`, { verfahren: 'POST', rumpf: { grund } });
}

export async function zuruecknehmen(id: string, grund: string): Promise<Kontozuordnung> {
  return rufe(`/kontozuordnungen/${id}/zuruecknehmen`, { verfahren: 'POST', rumpf: { grund } });
}
